import * as yup from 'yup';

export const slotsSchema = yup.object({
  slots: yup
    .array(
      yup.object({
        id: yup.string().transform(value => (value === '' ? undefined : value)),
        resources: yup
          .object({
            count: yup
              .number()
              .transform(value => (isNaN(value) ? undefined : value))
              .when('$isResourcesLinkedToVenue', {
                is: true,
                then: schema => schema.required('Number of tickets is required'),
                otherwise: schema => schema.transform(val => undefined)
              })
          })
          .when('$isResourcesLinkedToVenue', {
            is: true,
            then: schema => schema.required(),
            otherwise: schema => schema.transform(val => undefined)
          }),
        sessions: yup
          .array(
            yup
              .array(
                yup
                  .object({
                    from: yup
                      .date()
                      .required()
                      .min(new Date(), 'Start Time must be greater than or equal to today'),
                    to: yup
                      .date()
                      .required()
                      .min(yup.ref('from'), 'End Time must be greater than or equal to Start Time')
                  })
                  .required()
              )
              .required()
          )
          .required()
          .min(1)
      })
    )
    .min(1)
    .required('Slots are Required'),
  packageOverrides: yup.array(
    yup.object({
      id: yup.string().transform(value => (value === '' ? undefined : value)),
      title: yup.string(),
      price: yup.number().required('Price is required'),
      discount: yup
        .number()
        .required('Discount % is required')
        .min(0, 'Discount should be greater than 0')
        .max(100, 'Discount should be less than 100'),
      resources: yup
        .object({
          count: yup
            .number()
            .transform(value => (isNaN(value) ? undefined : value))
            .when('$isResourcesLinkedToVenue', {
              is: (val: boolean) => !val,
              then: schema => schema.required('Number of tickets is required'),
              otherwise: schema => schema.transform(val => undefined)
            })
        })
        .when('$isResourcesLinkedToVenue', {
          is: (val: boolean) => !val,
          then: schema => schema.required(),
          otherwise: schema => schema.transform(val => undefined)
        })
    })
  )
});

export type SlotsFormData = yup.InferType<typeof slotsSchema>;
